<template>
    <z-basePage :title="'奖金与职级'">
        <div class="tab-title">
            <div class="tab-btn" :class="{active:activeIndex==0}" @click="changeTab(0)">奖金分配设置</div>
            <div class="tab-btn" :class="{active:activeIndex==1}" @click="changeTab(1)">职级分配设置</div> 
        </div>
        <div class="tab">
            <div class="tab-main" v-show="activeIndex == 0">
                <bonusCycle></bonusCycle>
            </div>
            <div class="tab-main" v-show="activeIndex == 1">
                <rankCycle></rankCycle>
            </div>
        </div>
    </z-basePage>
</template>

<script>
    import bonusCycle from 'src/views/backEndStage/setting/bonus-cycle.vue'
    import rankCycle from 'src/views/backEndStage/setting/rank-cycle.vue'

    import { mapState } from "vuex"

    export default {
        components:{
            bonusCycle,
            rankCycle,
        },

        computed:{
            activeIndex(){
                return this.$route.query.tab || 0;
            },
        },

        beforeRouteLeave(to,from,next){  //离开页面之前
			let res;
            if(this.activeIndex == 0){
			    res = this.$form.leave({name:'back-bonus-cycle',path:to.path});
            }else if(this.activeIndex == 1){
                res = this.$form.leave({name:'back-rank-cycle',path:to.path});
            }
			next(res);
		},

        methods:{
            changeTab(val){  //记录激活的tab序号
                this.$router.push({
                    name:'back-setting-bonus&level',
                    query:{
                        tab:val
                    },
                });
            },
        },


    }
</script>

<style lang="less" scoped>
</style>





// WEBPACK FOOTER //
// page-bonus&level.vue?0c165fdc